import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { handleImageDialogClose } from '../../../../../common/properties/formFunctions';

const FileTypeErrorDialog = ({ component, fileTypeError }) => {
  const uploadImageErrorActions = [
    <FlatButton
      label="Halda áfram" labelStyle={{ color: '#222222' }}
      onTouchTap={() => handleImageDialogClose(component)}
    />,
  ];

  return (
    <Dialog
      title="Villa við það að hlaða inn mynd" actions={uploadImageErrorActions}
      modal={false} open={fileTypeError}
      onRequestClose={() => handleImageDialogClose(component)}
    >
      Það má ekki hlaða inn skrám sem eru ekki myndir.
    </Dialog>
  );
};

FileTypeErrorDialog.propTypes = {
  component: React.PropTypes.any.isRequired,
  fileTypeError: React.PropTypes.bool.isRequired,
};

export default FileTypeErrorDialog;



// WEBPACK FOOTER //
// ./src/browser/app/components/Dialogs/FileTypeErrorDialog/FileTypeErrorDialog.js